import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-matformfield',
	templateUrl:'./MatFormFieldPage.html',
	styles: [],
	styleUrls:['./MatFormFieldPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatFormFieldPage
{
	mdContent_253 = `\`\`\`java
import com.jwebmp.plugins.angular.material.formfield.MatFormField;
\`\`\``;
	mdContent_254 = `\`\`\`java
MatFormField()
\`\`\``;
	mdContent_255 = `\`\`\`java
MatFormField&lt;?&gt; field = new MatFormField&lt;&gt;();
field.setAppearance("outline");
field.setLabel("Email");
field.addHint("Enter your email address");
field.add(new InputTextType&lt;&gt;());
\`\`\``;
}
